import useSWR from 'swr';
import { API_BASE_URL } from '../../lib/constants';
import useBoundStore from '../../store';

export type ConstantType = {
  marketPriceDifference: number;
  saleDays: number;
};

export type APIRequestsRes = {
  saleDays: ConstantType[];
};

const useFacilityConstants = () => {
  const token = useBoundStore.getState().authToken;

  const fetcher = (url: string) =>
    fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

  const { data } = useSWR(`${API_BASE_URL}/facilities/constants`, fetcher);

  return data as APIRequestsRes;
};

export default useFacilityConstants;
